<div class="page-content container">
  <div class="page-header">
    <h1>
      {{ translationManager.getTranslation('Листа чланова тима/одбора за одобрење набавке') }}
    </h1>
  </div>
  <div class="page-data shadow-sm">
    <div class="page-part">
      <div class="alert alert-info">
        <span><i class="fa fa-info-circle"></i>
          {{ translationManager.getTranslation('Страница за приказ чланова тима/одбора за одобрење набавке') }}
        </span>
      </div>
      <div class="page-part">
        <br>
        <span><b>{{ translationManager.getTranslation('Рок за усаглашавање ОПН-а') }} :
            {{deadlineForCompletion | appdate | appvalue}}</b></span>
      </div>
    </div>
    <div class="page-part"
      *ngIf="auth.isAuthorized('CCBCF371-A968-4E00-B5EB-75EB13DAA7E7') &&
      state === viewState.Edit &&
    (requestStatus == requestStatusUniqueIdentifier.inProgress || requestStatus == requestStatusUniqueIdentifier.changesBack)">
      <div class="page-actions">
        <button class="btn btn-success" (click)="showCreateModal()"><i class="fa fa-plus mr-1"></i>
          {{ translationManager.getTranslation('Додати новог члана одбора') }}</button>
      </div>
    </div>

    <div class="app-table-panel" app-table>

      <div class="app-table">
        <table class="table table-striped text-dark-m1">
          <thead>
            <tr class="bgc-primary-tp2 text-white">
              <th>
                <!-- <a href="javascript:;"
                  [title]="translationManager.getTranslation('Сортирање по кадровској области')" order
                  order-entity="PersonnelAreaName">
                  {{ translationManager.getTranslation('Kадровскa област') }}
                </a> -->
                {{ translationManager.getTranslation('Kадровскa област') }}
              </th>

              <th>
                <!-- <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање по имену и презимену')" order
                  order-entity="FullName">
                  {{ translationManager.getTranslation('Име и презиме') }}
                </a> -->
                {{ translationManager.getTranslation('Име и презиме') }}
              </th>

              <th>
                <!-- <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање по позицији')" order
                  order-entity="EmployeePositionName">
                  {{ translationManager.getTranslation('Позиција') }}
                </a> -->
                {{ translationManager.getTranslation('Позиција') }}
              </th>

              <th>
                <!-- <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање по датој сагласности')" order
                  order-entity="IsGivenCompliance">
                  {{ translationManager.getTranslation('Дата сагласност') }}
                </a> -->
                {{ translationManager.getTranslation('Дата сагласност') }}
              </th>

              <th>
                <!-- <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање по датуму давања сагласности')" order
                  order-entity="ComplianceDate">
                  {{ translationManager.getTranslation('Датум давања сагласности (Да/Не)') }}
                </a> -->
                {{ translationManager.getTranslation('Датум давања сагласности (Да/Не)') }}
              </th>
              <th style="width: 140px" class="right" *ngIf="state === viewState.Edit">
                {{ translationManager.getTranslation('Акције') }}
              </th>
            </tr>
          </thead>
          <tbody>

            <tr *ngFor="let item of items">
              <td>{{item.personnelAreaName}}</td>
              <td>{{item.fullName}}</td>
              <td>{{item.employeePositionName}}</td>
              <td>{{item.isGivenCompliance===null?'': translationManager.getTranslation(item.isGivenCompliance) }}</td>
              <td>{{item.complianceDate | date:'dd.MM.YYYY'}}</td>

              <td class="right" *ngIf="state === viewState.Edit">
                <div class="table-actions">
                  <a *ngIf="auth.isAuthorized('E5D22D0E-AFEC-4020-A4C9-ECE2E2EDC61E') &&
                      (requestStatus == requestStatusUniqueIdentifier.inProgress || requestStatus == requestStatusUniqueIdentifier.changesBack)"
                    href="javascript:;" (click)="showDeleteModalFor(item.id)" class="red"
                    [title]="translationManager.getTranslation('Брисање')">
                    <i class="far fa-trash-alt"></i>
                  </a>
                </div>
              </td>
            </tr>

          </tbody>
        </table>
        <div class="no-content" *ngIf="!items || items.length == 0">
          <span>{{ translationManager.getTranslation('Без података') }}</span>
        </div>
      </div>

      <!-- <div class="app-table-pagination">
        <div>
          <div pagination>
            <span>{{ translationManager.getTranslation('Страна') }}</span>
            <select pagination-pages>
              <option>1</option>
            </select>
            <span>{{ translationManager.getTranslation('од') }}</span>
            <span pagination-pages-count>-</span>
            <span class="app-table-pagination-arrows">
              <a href="javascript:;" [title]="translationManager.getTranslation('Иди на почетак')"
                pagination-first-page>
                <i class="fas fa-angle-double-left"></i>
              </a>
              <a href="javascript:;" [title]="translationManager.getTranslation('Претходна')" pagination-previous-page>
                <i class="fas fa-angle-left"></i>
              </a>
            </span>
            <span class="app-table-pagination-arrows">
              <a href="javascript:;" [title]="translationManager.getTranslation('Следећа')" pagination-next-page>
                <i class="fas fa-angle-right"></i>
              </a>
              <a href="javascript:;" [title]="translationManager.getTranslation('Иди на крај')" pagination-last-page>
                <i class="fas fa-angle-double-right"></i>
              </a>
            </span>
            <span>{{ translationManager.getTranslation('Број редова за приказ') }}</span>
            <select pagination-sizes>
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
        </div>
        <div class="app-table-pagination-sizes">
          <div>
            <span>{{ translationManager.getTranslation('Укупан број слогова') }}</span>
            <span pagination-total-count>-</span>
          </div>
        </div>
      </div> -->

    </div>
  </div>
</div>


<app-modal [show]="showDeleteModal"
  [title]="translationManager.getTranslation('Брисање члана тима/одбора за одобрење набавке?')">
  <div class="app-modal-content">
    {{ translationManager.getTranslation('Да ли сте сигурни да желите да обришете члана тима/одбора за одобрење набавке?') }}
  </div>
  <div class="app-modal-actions">
    <button class="btn btn-success" (click)="delete()">
      <i class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Да') }}</button>
    <button (click)="showDeleteModal = false" class="btn btn-warning">
      <i class="fa fa-times mr-2"></i>{{ translationManager.getTranslation('Не') }}</button>
  </div>
</app-modal>

<opn-boardmember-list #opnBoardMemberListComponent></opn-boardmember-list>
